// Add a handler to the click event of the element that launches Fancybox
document.addEventListener('DOMContentLoaded', function() {
  Fancybox.bind('[data-fancybox]', {
    // Your custom options
  });
});
